// extracted by mini-css-extract-plugin
export default {"block":"block_block__tcLDG"};